import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This modern coastal garden features a simple yet bold use of low maintenance water-wise plants. The design combines soft greens and glaucous greys, hardy succulents and architectural style accent plants as well as local sandstone ballast walling. The restrained palette complements the modern styling of the residence and the magnificent view beyond.',
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Architecture
          <br />Construction
          <br />Ongoing Maintenance
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Entertainer
          <br />Courtyard/Rooftop
          <br />Seaside
          </p>
        ),
        image : '../images/projects/balmoral-1.jpg',
        title : 'Balmoral'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/balmoral-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/balmoral-2.jpg"'
    },
    {
        dataId : 'a2',
        image : '../images/projects/balmoral-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/balmoral-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/balmoral-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/balmoral-6.jpg'
    },
]

const PageBalmoral = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageBalmoral